<div class="ipm-container p-0">
    <div class="ipm-help-support-section">
        <div class="ipm-header-section">
            <h2>
                <ng-container *ngIf="type === 'orderHelpSupport'">
                    {{this.currentSelectedOption?.title}}
                </ng-container>
                <ng-container *ngIf="type !== 'orderHelpSupport'">
                    Help and Support
                </ng-container>
            </h2>
             <div class="ipm-close-icon" (click)="closePopup()">
                <i class="pi pi-times"></i>
            </div>
        </div>
        <div class="ipm-help-section">
            <div class="row">
                <div class="col-12 set-border-list">
                    <div class="ipm-help-option mb-2">
                        <div class="ipm-heading">
                            Select Your Issue
                        </div>
                        <mat-radio-group (change)="onChangeRadio($event)">
                            <mat-radio-button class="ipm-radio-button " *ngFor="let value of helpListData" [value]="value">
                                {{value}}
                            </mat-radio-button>
                            <!-- <div class="mobile-view">
                                <ng-container  *ngIf="!currentSelectedData ; else messageSection"></ng-container>
                            </div> -->
                        </mat-radio-group>
                    </div>
                </div>
                <ng-container *ngIf="type === 'orderHelpSupport' && beatList.length > 0">
                    <div class="col-12 mb-3">
                        <div class="ipm-select-beat-section">
                            <div class="ipm-heading">
                                Select item
                            </div>
                            <div class="ipm-beat-list-wrapper" infinite-scroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="0">
                                <ng-container *ngFor="let beatData of beatList; let i = index">
                                    <div class="ipm-beat-item">
                                        <div class="ipm-action">
                                            <div class="ipm-custom-checkbox ipm-padding-right">
                                                <p-checkbox [binary]="true" [inputId]="'beat-select'+i"
                                                    [name]="'beat-select'" [(ngModel)]="beatData.isSelected"
                                                    [ngModelOptions]="{standalone: true}"></p-checkbox>
                                            </div>
                                        </div>
                                        <div class="ipm-img-wrapper">
                                            <div class="ipm-beat-info-section">
                                                    <figure>
                                                        <div class="ipm-image-wrapper">
                                                            <img priority priority [src]="beatData?.beat ? beatData?.beat?.cover_picture : beatData?.sound?.coverImageUrl" alt="beat-image" width="42px"
                                                            (error)="browserService.errorHandler($event)" height="48px">
                                                        </div>
                                                        <figcaption>
                                                            <div class="beat-basic-info">
                                                                <span class="beat-title-name">
                                                                    {{beatData?.beat ? beatData?.beat?.title : beatData?.sound?.title}}
                                                                </span>
                                                                <span class="beat-tag">
                                                                     {{beatData?.beat ? 'Beat' : 'Sound Kit'}}
                                                                    
                                                                </span>
                                                            </div>
                                                        </figcaption>
                                                    </figure>
                                                </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </ng-container>
                
                <div class="col-12">
                    <div class="ipm-section-message">
                        <ng-container *ngTemplateOutlet="messageSection"></ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #messageSection>
    <div class="ipm-message-input-section">
        <div class="ipm-heading">
            Please explain your problem in detail
        </div>
        <div class="custom-form">
            <div class="custom-form-group">
                <textarea name="message" id="message"
                        placeholder="Type here"
                        [formControl]="textMessage"
                        [class.ipm-error-border]="textMessage.invalid && textMessage.touched"
                        class="form-contol" rows="5" required></textarea>
                <div class="ipm-error-icon" *ngIf="textMessage.invalid && textMessage.touched">
                    <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                </div>
                <div class="help-block error-message"
                    *ngIf="textMessage.invalid && textMessage.touched">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    {{formService.getErrorMessage(textMessage)}}
                </div>
            </div>
        </div>
        <div class="ipm-actions">
            <button class="btn ipm-submit-btn" (click)="submitHelpRequest()" 
                [disabled]="!isFormValid()">
                Submit the issue
            </button>
        </div>
    </div>
</ng-template>
